export const statusCopy = {
  labels: {
    noChange: 'No change',
    noData: 'No data',
    noRuns: 'No runs',
    unknown: 'Unknown',
  },
} as const;

export type StatusCopyKey = keyof typeof statusCopy.labels;

export const getStatusCopy = (key: StatusCopyKey): string => statusCopy.labels[key];

export const getStatusCopySamples = (): string[] => Object.values(statusCopy.labels);
